import { Mapper } from '../../../common/ddd/mapper.base';
import { IAnalyticsActivityEnum } from '../../../common/enum/analytics-activity/analytics-activity.enum';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { SelfInteractionsGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-interactions-goal.entity';
import { GetSelfGoalSummaryResponseDto } from '../../../interface/dtos/goals/get-self-goal-summaries.response.dto';

export interface ISelfInteractionsGoalPersistenceResponse {
  [IAnalyticsActivityEnum.Count]: string;
}

export class SelfInteractionsGoalMapper
  implements Mapper<SelfInteractionsGoalEntity, any>
{
  toDomain(
    record: ISelfInteractionsGoalPersistenceResponse
  ): SelfInteractionsGoalEntity {
    return SelfInteractionsGoalMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfInteractionsGoalPersistenceResponse
  ): SelfInteractionsGoalEntity {
    const entity = SelfInteractionsGoalEntity.create({
      appMetric: Number(record[IAnalyticsActivityEnum.Count]),
    });
    return entity;
  }

  toResponse(
    entity: SelfInteractionsGoalEntity
  ): GetSelfGoalSummaryResponseDto {
    return SelfInteractionsGoalMapper.toResponse(entity);
  }

  static toResponse(
    entity: SelfInteractionsGoalEntity
  ): GetSelfGoalSummaryResponseDto {
    return {
      currentValue: `${entity.appMetric}`,
      percentageDifference: entity.deviationFromGoalPercentage,
      formattedPercentageDifference: formatDeviation(
        entity.deviationFromGoalPercentage
      ),
    };
  }
}
